import { requestsRepo } from '@/constants/providers';
import { KpiFilterType, SortDirection } from '@/shared';
import { KpisDetailsRowsPerPage } from '@/shared/constants';
import { useInfiniteQuery } from '@tanstack/react-query';
import { mapStatusFilterToStatus } from '../mappers';
import { RequestsKey } from './types';
import { OrganizationContext } from '@/components/OrganizationProvider/OrganizationProvider';
import { useContext } from 'react';

type GetRequestsKpiParams = {
  onlyActiveRequests: boolean;
  sortBy?: string;
  sortOrder?: SortDirection;
  rowsPerPage?: number;
  pageNumber?: number;
  filterBy?: KpiFilterType;
  filter?: string | number;
};

export const useGetRequestsKpisDetailsInfinite = ({
  onlyActiveRequests,
  filter,
  filterBy,
  sortBy,
  sortOrder,
  rowsPerPage = KpisDetailsRowsPerPage,
}: GetRequestsKpiParams) => {
  const kpiFilters: string[] = [];

  if (filter && filterBy == KpiFilterType.Typology) {
    kpiFilters.push(`typologies__=__${filter}`);
  }

  if (filter && filterBy == KpiFilterType.Claimant) {
    kpiFilters.push(`createdBy__=__${filter}`);
  }

  if (
    filter &&
    filterBy == KpiFilterType.Status &&
    typeof filter === 'number'
  ) {
    kpiFilters.push(`status__in__[${mapStatusFilterToStatus(filter)}]`);
  }

  if (filter && filterBy == KpiFilterType.Reference) {
    kpiFilters.push(`reference__like__${encodeURIComponent(`%${filter}%`)}`);
  }

  const filters = {
    onlyActiveRequests,
    filter: kpiFilters.length ? kpiFilters.join(';') : undefined,
  };

  const { organizationId } = useContext(OrganizationContext);

  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: [
      ...RequestsKey.REQUESTS_KPI_DETAILS(filters, sortBy, sortOrder),
      organizationId,
    ],
    queryFn: ({ pageParam }) =>
      requestsRepo.getRequestsKpiDetails(
        filters,
        sortBy,
        sortOrder,
        pageParam,
        rowsPerPage,
      ),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length < rowsPerPage ? undefined : allPages.length + 1;
    },
  });
};
